import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';

const AddressLogButtons = ({ closeView }) => {
  return <SecondaryButton text={formatMessage(Messages.common_close)} onClickEvent={closeView} />;
};

export default AddressLogButtons;
